import React, { useState, useEffect } from 'react';

const SearchTabs = props => {

    const [activeTab, setActiveTab] = useState(props.location);

    const postTypes = [
        {
            display_name: 'Articles',
            post_type: ['post'],
            category: '',
            tab_type: 'post'
        },
        {
            display_name: 'Products',
            post_type: ['product'],
            category: '',
            tab_type: 'product'
        },
        {
            display_name: 'Podcasts',
            post_type: ['post'],
            category: 'podcast',
            tab_type: 'podcast'
        },
        {
            display_name: 'Videos',
            post_type: ['post'],
            category: 'video',
            tab_type: 'video'
        },
        {
            display_name: 'Database',
            post_type: 'database',
            category: '',
            tab_type: 'database'
        },
    ];

    useEffect(() => {
        
        if(props.location) {
            setActiveTab(props.location);
        }

    }, []);


    const handleTabClick = (id, data) => {
        setActiveTab(data.display_name);
        props.handleSetType(data);
        props.handleTabChange(data.tab_type);
    };

    const getClassList = (current, index) => {
        let classList = 'tab';

        if ((activeTab === null && index === 0) || current === activeTab) {
            classList += ' tab--active';
        }

        return classList;
    };

    return (
        <div className="search-tabs-wrapper">
            <div className="tabs tabs--search search-listing__tabs search-listing__tabs--arrowed search-listing__tabs--padded">
                {Object.values(postTypes).map((data, index) => (
                    <h2
                        key={index}
                        className={getClassList(data.display_name, index)}
                        onClick={() => handleTabClick(index, data)}>
                        <span className="tab__identifier">{data.display_name}</span>
                        &nbsp;<span className="tab__total">{props.results[data.display_name]}</span>
                    </h2>
                ))}
            </div>
        </div>
    );
};

export default SearchTabs;
